module.exports = __webpack_public_path__ + "static/media/sm-logo.77c821b1.svg";